/**
 * relationship-partner-request.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Message, ReplyVerifyingMessage } from "../general/";
import { MessageTag } from "../message-tag";

export class RelationshipPartnerRequest
    extends ReplyVerifyingMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag =
        MessageTag.REQ_RELATIONSHIP_PARTNER;

    /**
     * The partner request expects a {@link SubjectContextResponse} in return.
     */
    public verifyReply (reply : Message) : boolean
    {
        return Message.isA(reply, MessageTag.RSP_SUBJECT_CONTEXT);
    }

    constructor (
        public subjectId : number,
        public relationshipId : number
    )
    {
        super();
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/subjects/relationship-partner-request.ts